import React from 'react';
import WidgetReference from './WidgetReference';

export default function Referrals() {
  return (
    <>
      <WidgetReference guideId="referrals" />
    <iframe
      src="https://scribehow.com/embed/Updating_Shopify_Referral_Program_Settings__o4XPeuT9T2utZSOnlMX0XQ?skipIntro=true&removeLogo=true&as=scrollable"
      height="640"
      title="Referrals"
      allowFullScreen
    />
    </>
  );
}
